import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Spin,
  DatePicker,
  Form,
  notification,
  Tooltip,
} from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import IconWithTextCard from "./Chartjs/PosHomeWidget";
import RequestHandler from "../../util/RequestHandler";
import PosChart from "./Chartjs/PosColumnChart";
import PosDonutPlotChart from "./Chartjs/PosDonutPlotChart";
import PosGroupColumnChart from "./Chartjs/PosGroupColumnChart";
import PosMultiLinePlotChart from "./Chartjs/PosMultiLinePlotChart";
import moment from "moment";

function PosReports() {
  const [monthlyPosVolumeData, setMonthlyPosVolumeData] = useState("");
  const [todayValorAmountValue, setTodayValorAmountValue] = useState({});
  const [returnTransactionValue, setReturnTransactionValue] = useState({});
  const [monthlyBankBasedTotalAmounts, setMonthlyBankBasedTotalAmounts] =
    useState([]);
  const [monthlyBankCommissionAmount, setMonthlyBankCommissionAmount] =
    useState([]);
  const [
    monthlyBankTotalCommissionAmount,
    setMonthlyBankTotalCommissionAmount,
  ] = useState([]);
  const [mostMonthlyUsedPos, setMostMonthlyUsedPos] = useState([]);
  const [leastMonthlyUsedPos, setLeastMonthlyUsedPos] = useState([]);
  const [forwardValueDateAmount, setForwardValueDateAmount] = useState([]);

  var today = new Date();
  const todayMoment = moment();
  const nextWeek = moment(todayMoment).add(7, "days");
  const yearA = todayMoment.format("YYYY");
  const monthA = todayMoment.format("MM");
  const defaultDates = moment(`${yearA}/${monthA}`, "YYYY/MM").format(
    "YYYY/MM"
  );

  const [bankBasedVolumeDate, setBankBasedVolumeDate] = useState(defaultDates);

  const [dateRange, setDateRange] = useState({
    startValorDate: moment().format("YYYY.MM.DD"),
    endValorDate: moment().format("YYYY.MM.DD"),
    datePicture: false,
  });
  const [loading, setLoading] = useState(true);
  const [loadingMonthlyBankAmount, setLoadingMonthlyBankAmount] =
    useState(true);
  const [loadingMostMonthlyUsedPos, setloadingMostMonthlyUsedPos] =
    useState(true);
  const [loadingleastMonthlyUsedPos, setloadingleastMonthlyUsedPos] =
    useState(true);
  const [isLoadingForwardValueDate, setIsLoadingForwardValueDate] =
    useState(true);
  const [
    loadingmonthlyBankBasedTotalAmountsReport,
    setloadingmonthlyBankBasedTotalAmountsReport,
  ] = useState(true);
  const [userSelectedDate, setUserSelectedDate] = useState(false);

  useEffect(() => getMonthlyPosVolumeReport(), []);
  useEffect(() => todayValueAmountReport(), []);
  useEffect(() => returnTransactionTotalValueReport(), []);
  useEffect(() => monthlyBankCommissionTotalsReport(), []);
  useEffect(() => mostMonthlyUsedPosReport(), []);
  useEffect(() => leastMonthlyUsedPosReport(), []);
  useEffect(() => forwardValueDateAmountReport(), [dateRange]);

  useEffect(() => {
    if (!userSelectedDate) {
      const requestData = {
        endDate: "0001-01-01",
      };
      RequestHandler.post(
        `/PosTransactionReport/MonthlyBankBasedTotalAmountsReport`,
        requestData,
        false
      ).then((response) => {
        setMonthlyBankBasedTotalAmounts(response);
        setLoadingMonthlyBankAmount(false);
      });
    } else {
      const requestData = {
        endDate: bankBasedVolumeDate.format("YYYY-MM-DD"),
      };
      RequestHandler.post(
        `/PosTransactionReport/MonthlyBankBasedTotalAmountsReport`,
        requestData,
        false
      ).then((response) => {
        setMonthlyBankBasedTotalAmounts(response);
        setLoadingMonthlyBankAmount(false);
      });
    }
  }, [userSelectedDate, bankBasedVolumeDate]);

  const getMonthlyPosVolumeReport = () => {
    RequestHandler.get("/PosTransactionReport/MonthlyValueReport").then(
      (response) => {
        setMonthlyPosVolumeData(response);
        setLoading(false);
      }
    );
  };

  const todayValueAmountReport = () => {
    RequestHandler.get(
      "/PosTransactionReport/TodayScheduledValueAmountReport"
    ).then((response) => {
      setTodayValorAmountValue(response.netAmount);
      setLoading(false);
    });
  };

  const returnTransactionTotalValueReport = () => {
    RequestHandler.get("/PosTransactionReport/ReturnTransactionsReport").then(
      (response) => {
        setReturnTransactionValue(response.amount);
        setLoading(false);
      }
    );
  };

  // const monthlyBankBasedTotalAmountsReport = () => {
  //   const requestData = {
  //     endDate: bankBasedVolumeDate,
  //   };
  //   RequestHandler.post(
  //     `/PosTransactionReport/MonthlyBankBasedTotalAmountsReport`,
  //     requestData,
  //     false
  //   ).then((response) => {
  //     setMonthlyBankBasedTotalAmounts(response);
  //     setLoadingMonthlyBankAmount(false);
  //   });
  // };

  const monthlyBankCommissionTotalsReport = () => {
    RequestHandler.get(
      "/PosTransactionReport/MonthlyBankCommissionTotalsReport"
    ).then((response) => {
      setMonthlyBankCommissionAmount(response);
      var lastIndex = response[response.length - 1];
      setMonthlyBankTotalCommissionAmount(lastIndex.commissionAmount);
      setloadingmonthlyBankBasedTotalAmountsReport(false);
    });
  };

  const mostMonthlyUsedPosReport = () => {
    RequestHandler.get("/PosTransactionReport/MostMonthlyUsedPosReport").then(
      (response) => {
        setMostMonthlyUsedPos(response);
        setloadingMostMonthlyUsedPos(false);
      }
    );
  };

  const leastMonthlyUsedPosReport = () => {
    RequestHandler.get("/PosTransactionReport/LeastMonthlyUsedPosReport").then(
      (response) => {
        setLeastMonthlyUsedPos(response);
        setloadingleastMonthlyUsedPos(false);
      }
    );
  };

  const forwardValueDateAmountReport = () => {
    const requestData = {
      endDate: dateRange.endValorDate,
      startDate: dateRange.startValorDate,
      datePicker: dateRange.datePicture,
    };
    RequestHandler.post(
      `/PosTransactionReport/ForwardValueDateAmountReport`,
      requestData,
      false
    ).then((response) => {
      setForwardValueDateAmount(response);
      setIsLoadingForwardValueDate(false);
    });
  };

  function formatAmount(amount) {
    const formattedAmount = new Intl.NumberFormat("tr-TR", {
      style: "currency",
      currency: "TRY",
      minimumFractionDigits: 2,
    }).format(amount);

    return formattedAmount;
  }

  //#region  Ayın tarihini SubTitle alanına işler.
  const currentDate = new Date();
  const firstDayOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  );
  const lastDayOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
    0
  );

  const startDate = formatDate(firstDayOfMonth);
  const endDate = formatDate(lastDayOfMonth);

  function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  function formatCustomDateRange(startDate, endDate) {
    const startDay = startDate.getDate();
    const endDay = endDate.getDate();
    const startMonth = startDate.toLocaleString("default", { month: "long" });

    return `${startDay}-${endDay} ${startMonth}`;
  }
  //#endregion

  const ayAdlari = [
    "Ocak",
    "Şubat",
    "Mart",
    "Nisan",
    "Mayıs",
    "Haziran",
    "Temmuz",
    "Ağustos",
    "Eylül",
    "Ekim",
    "Kasım",
    "Aralık",
  ];

  var day = today.getDate();
  var month = ayAdlari[today.getMonth()];

  const handleDateRangeChange = (dates) => {
    if (dates && dates.length === 2) {
      const [newStartValorDate, newEndValorDate] = dates;

      if (newStartValorDate && newEndValorDate) {
        const diffInDays = Math.abs(
          newEndValorDate.diff(newStartValorDate, "days")
        );

        if (diffInDays > 30) {
          notification.error({
            message: "Hata",
            description:
              "Başlangıç ve bitiş tarihleri arasındaki fark 30 günden fazla olamaz.",
          });

          const startFormattedDate = newStartValorDate.format("YYYY.MM.DD");

          setDateRange({
            startValorDate: startFormattedDate,
            endValorDate: moment(startFormattedDate)
              .add(30, "days")
              .format("YYYY.MM.DD"),
            datePicture: true,
          });
        } else {
          const startFormattedDate = newStartValorDate.format("YYYY.MM.DD");
          const endFormattedDate = newEndValorDate.format("YYYY.MM.DD");

          setDateRange({
            startValorDate: startFormattedDate,
            endValorDate: endFormattedDate,
            datePicture: true,
          });
        }
      }
    } else {
      const todayFormattedDate = moment().format("YYYY.MM.DD");

      setDateRange({
        startValorDate: todayFormattedDate,
        endValorDate: todayFormattedDate,
        datePicture: false,
      });
    }
  };

  return (
    <div>
      <Spin spinning={loading}>
        <Row justify="space-between">
          <IconWithTextCard
            icon="revenue-new"
            title={formatAmount(monthlyPosVolumeData.amount)}
            subTitle={formatCustomDateRange(firstDayOfMonth, lastDayOfMonth)}
            descText={<span style={{ color: "green" }}>TOPLAM TUTAR</span>}
          />
          <IconWithTextCard
            icon="revenue-new"
            title={formatAmount(monthlyPosVolumeData.commissionAmount)}
            subTitle={formatCustomDateRange(firstDayOfMonth, lastDayOfMonth)}
            descText={<span style={{ color: "red" }}>KOMİSYON TUTARI</span>}
          />
          <IconWithTextCard
            icon="revenue-new"
            title={formatAmount(monthlyPosVolumeData.netAmount)}
            subTitle={formatCustomDateRange(firstDayOfMonth, lastDayOfMonth)}
            descText={<span style={{ color: "green" }}>NET TUTAR</span>}
          />
          <IconWithTextCard
            icon="revenue-new"
            title={formatAmount(returnTransactionValue)}
            subTitle={formatCustomDateRange(firstDayOfMonth, lastDayOfMonth)}
            descText={
              <span style={{ color: "red" }}>İADE EDİLEN HESAP TUTARI</span>
            }
          />
          <IconWithTextCard
            icon="revenue-new"
            title={formatAmount(todayValorAmountValue)}
            subTitle={
              <span>
                {day} {month}
              </span>
            }
            impWidth="true"
            descText={
              <span style={{ color: "green" }}>
                 HESABA GEÇMESİ PLANLANAN VALÖR 
              </span>
            }
          />
        </Row>

        <Row justify="center">
          <Col xs={24} md={12} lg={24}>
            <Card>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 15,
                }}
              >
                <h2>BANKA BAZLI HACİM</h2>
                <Form.Item name="bankaBazliHacim">
                  <DatePicker
                    picker="month"
                    format="MM.YYYY"
                    defaultValue={moment(bankBasedVolumeDate, "YYYY/MM")}
                    clearIcon={null}
                    // value={defaultDate}
                    onChange={(date, dateString) => {
                      setBankBasedVolumeDate(date);
                      setUserSelectedDate(true);
                    }}
                  />
                </Form.Item>
              </div>

              <PosMultiLinePlotChart
                data={monthlyBankBasedTotalAmounts}
                isLoading={loadingMonthlyBankAmount}
              />
            </Card>
          </Col>
        </Row>

        <Row justify="center">
          <Col xs={24} md={12} lg={24}>
            <Card>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 15,
                }}
              >
                <h2>BANKA BAZLI VALÖR</h2>
                <Form.Item name="bankaBazliValör" label="Tarih :">
                  <DatePicker.RangePicker
                    format="DD.MM.YYYY"
                    defaultValue={[todayMoment, nextWeek]}
                    onChange={handleDateRangeChange}
                    onCalendarChange={(dates) => {
                      if (dates && dates.length === 2) {
                        const [newStartValorDate, newEndValorDate] = dates;

                        if (newStartValorDate && newEndValorDate) {
                          const diffInDays = Math.abs(
                            newEndValorDate.diff(newStartValorDate, "days")
                          );

                          if (diffInDays > 30) {
                            const newEndDate = moment(newStartValorDate).add(
                              30,
                              "days"
                            );
                            setDateRange({
                              startValorDate: newStartValorDate,
                              endValorDate: newEndDate,
                              datePicture: true,
                            });
                          } else {
                            setDateRange({
                              startValorDate: newStartValorDate,
                              endValorDate: newEndValorDate,
                              datePicture: true,
                            });
                          }
                        }
                      } else {
                        setDateRange({
                          startValorDate: moment().format("YYYY.MM.DD"),
                          endValorDate: moment().format("YYYY.MM.DD"),
                          datePicture: false,
                        });
                      }
                    }}
                    value={[dateRange.startValorDate, dateRange.endValorDate]}
                  />
                </Form.Item>
              </div>
              <PosGroupColumnChart
                data={forwardValueDateAmount}
                isLoading={isLoadingForwardValueDate}
              />
            </Card>
          </Col>
        </Row>

        <Row justify="center">
          <Col xs={24} sm={12} md={1} lg={8}>
            <Card>
              <h2>
                Bankalara Göre Komisyon Tutarları{" "}
                <Tooltip title="Son 1 aylık işlemlere göre veriler görüntülenmektedir.">
                  <InfoCircleOutlined
                    style={{ color: "green", fontSize: "80%" }}
                  />
                </Tooltip>
              </h2>

              <p style={{ fontSize: 25 }}>
                {formatAmount(monthlyBankTotalCommissionAmount)}
              </p>

              <PosDonutPlotChart
                data={monthlyBankCommissionAmount}
                totalCommissionAmount={formatAmount(
                  monthlyPosVolumeData.commissionAmount
                )}
                isLoading={loadingmonthlyBankBasedTotalAmountsReport}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} md={8} lg={8}>
            <Card>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  marginBottom: 15,
                }}
              >
                <h2>En Çok Kullanılan Pos</h2>
              </div>
              <PosChart
                data={mostMonthlyUsedPos}
                isLoading={loadingMostMonthlyUsedPos}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} md={8} lg={8}>
            <Card>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  marginBottom: 15,
                }}
              >
                <h2>En Az Kullanılan Pos</h2>
              </div>
              <PosChart
                data={leastMonthlyUsedPos}
                isLoading={loadingleastMonthlyUsedPos}
              />
            </Card>
          </Col>
        </Row>
      </Spin>
    </div>
  );
}

export default PosReports;
